function setScrollAnchorPosition(container) {
    if (window.location.hash) {
        const el = container.querySelector('[data-id="' + window.location.hash.replace('#', '') + '"]');

        if (el !== null) {
            const bounds = el.getBoundingClientRect();
            vanillaSmoothie.scrollTo(bounds.top + window.scrollY, { duration: 500, easing: 'easeInOutQuad' });
        }
    }
}